import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const toolbarSlice = createSlice({
  name: "toolbar",
  initialState: [],
  reducers: {
    initializeState(state, action) {
      let currentToolbar = state.find(
        (toolbar) => toolbar.toolbarName === action.payload.toolbarName
      );

      if (!currentToolbar) {
        state.push({
          toolbarName: action.payload.toolbarName,
          values: [],
        });
      }
    },
    updateValue: (state, action) => {
      let currentToolbar = state.find(
        (toolbar) => toolbar.toolbarName === action.payload.toolbarName
      );

      let currentValue = currentToolbar.values.find(value => value.name === action.payload.actionName);
      if (currentValue) {
        currentValue.value = action.payload.value;
      } else {
        currentToolbar.values.push({name: action.payload.actionName, value: action.payload.value});
      }
    }
  },
});

export const useToolbarSelector = (name) =>
  useSelector((state) => state.toolbar.find((tb) => tb.toolbarName === name));

const getActionValue = ({ toolbarName, actionName }) => {
  let toolbar = useToolbarSelector(toolbarName);
  return toolbar?.values.find((action) => action.name === actionName)?.value;
};

export const toolbarActions = {...toolbarSlice.actions, getActionValue};
export default toolbarSlice.reducer;
